module.exports = __webpack_public_path__ + "static/logo-050ad77364863a0e6b03f051e87cfa62.png";